import { Component, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Idle } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import { DxDataGridComponent } from 'devextreme-angular';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../shared/config/app-config';
import { Errors, FormSessionCanDeactivate, PatientService, UserService } from '../shared';

@Component({
  selector: 'app-manage-client-user',
  templateUrl: './manage-client-user.component.html',
  styleUrls: ['./manage-client-user.component.css']
})
export class ManageClientUserComponent extends FormSessionCanDeactivate {
  params: any;
  userList: any;
  @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;
  getTotalPageCount() {
    return `Page {0} of {1} ({2} items)`;
  }
  constructor(private userService: UserService, private nav: ActivatedRoute, private router: Router, private patientservice: PatientService, private fb: FormBuilder, private idle: Idle,
    private keepalive: Keepalive, private toast: ToastrService,
    private modalService: BsModalService,
    private localeService: BsLocaleService) {

    super();
    this.nav.params
      .subscribe(data => {
        this.params = data
      })
    this.reauth = this.fb.group({
      'password': ['', Validators.required]
    });
  }
  currentUser: any;
  dateValidation: any = false;
  imageURL: string = environment.cloudeImageURL;
  dateformat: any;
  clientList: any;
  setMode: any;
  setName: any;
  ulname: any;
  ufname: any;
  public timealert = environment.timelimit;
  uname: any;
  errors: Errors = new Errors();
  isSubmitting = false;
  reauth: FormGroup;
  ngOnInit() {

    this.setMode = 'all'

    this.userService.currentUser.subscribe(
      (userData) => {
        this.currentUser = userData;
        this.currentUser.status = true;
        if (this.currentUser.item) {
          //this.setmask = this.currentUser.item.phoneFormat.split('#').join('0');

          if (this.currentUser.item.dateFormat.toLowerCase() == 'mmddyyyy') {
            this.dateformat = environment.dateFormat;
          } else if (this.currentUser.item.dateFormat.toLowerCase() == 'ddmmyyyy') {
            this.dateformat = 'DD/MM/YYYY'
          }
          //this.bsConfig = Object.assign({}, { containerClass: 'theme-dark-blue',showWeekNumbers: false,dateInputFormat: this.dateformat});
        }
      });

    if (this.currentUser.item.hostModel == "CLOUD")
      this.imageURL = environment.cloudeImageURL;
    else
      this.imageURL = environment.vmImageURL;

    this.getUserList();
  }




  getUserList() {
    let self = this;
    self.userService.getUserListByHospital(self.params.id)
      .subscribe((data) => {
        //  self.tem_var= true;
        self.userList = data;
        self.setName = data[0] ? data[0].practiceName : "";
        //console.log("userDetails", self.userList)
        //  this.userid=data[0].userId;
        //  //console.log( this.userid)
        for (var i = 0; i < this.userList.length; i++) {
          if (this.userList[i].status == 1) {
            this.userList[i].stat = 'Active'
          } else if (this.userList[i].status == 3) {
            this.userList[i].stat = 'Deactivated'
          } else if (this.userList[i].status == 4) {
            this.userList[i].stat = 'Account Locked'
          }
          else {
            this.userList[i].stat = 'Not Activated'
          }
        }
      }, (err) => {
        //self.tem_var= true;
        self.userList = []
      })
  }


  loginAsCareCoordinator(selectionUser) {
    let self = this;
    //  this.logout();
    self.patientservice.getPatientPassword(selectionUser.userName, this.currentUser.item.userAccountId)
      .subscribe(data => {
        if (data.item.status == 'success') {
          window.localStorage['officeUser'] = this.currentUser.item.userAccountId
          const credentials = {
            'username': data.item.uname,
            'password': data.item.pwd,
            'captcha': '',
            'mode': '',
            'usermode': localStorage.getItem('userMode') ? atob(localStorage.getItem('userMode')) : 'a',
            'forcelogin': 'true',
            'officeUser': this.currentUser.item.userAccountId,
            'switchPortal': ""
          }
          let adminId = self.currentUser.item.userAccountId
          let adminuser = self.currentUser.item.userId
          window.localStorage['adminnamefname'] = self.currentUser.item.firstName
          window.localStorage['adminnamelname'] = self.currentUser.item.lastName
          self.userService.logAudit('getPassword', 0).subscribe(data => { })
          //  this.loginCareCoordinatorpage(credentials,selectionUser.patientSWId);
          // var pasEnc = btoa(data.item.pwd);
          // var pasEnc = encodeURIComponent(btoa(data.item.pwd));
          this.userService
            .attemptAuth(credentials)
            .subscribe(

              data => {
                if (data && adminId && adminuser) {
                  window.localStorage['superClientId'] = adminId
                  window.localStorage['stykerAdminUser'] = adminuser
                }
                window.localStorage.removeItem('session');
              }
            );
          // let patientSWId:any;
          // if(!selectionUser.patientSWId){
          //   patientSWId = "undefined";
          // }
          // else{
          //   patientSWId = selectionUser.patientSWId;
          // }
          // //window.location.href = environment.directCN_url+'/#/loginascn/'+data.item.uname+"/"+pasEnc+"/"+selectionUser.patientSWId;
          // this.router.navigateByUrl('/loginascn/'+data.item.uname+"/"+pasEnc+"/"+selectionUser.patientSWId);

          // this.router.na

          // this.router.navigateByUrl('/care/mytodo');

        }
      })
  }
  logout() {
    this.userService.logoutuser(this.currentUser.item.useAccountId)
    this.userService.purgeAuth();
    if (window.localStorage['plogin']) {
      var plogin = window.localStorage['plogin']
      window.localStorage.removeItem('plogin');
      //window.localStorage.clear()
      this.router.navigateByUrl('/plogin/' + plogin);

    } else {
      //this.currentUser.status==false
      //window.localStorage.clear()
      this.router.navigateByUrl('/login');
    }
  }
  show = false;
  public ModelRef: BsModalRef;
  username: any = "";
  password: any = "";
  toggleShow(event, id, inputid) {
    this.show = !this.show;

    if (this.show) {
      $(`#${id}`).removeClass('fa-eye')
      $(`#${id}`).addClass('fa-eye-slash')
      let input = $(`#${inputid}`);
      input.attr('type', 'text')
    } else {
      $(`#${id}`).removeClass('fa-eye-slash')
      $(`#${id}`).addClass('fa-eye')
      let input = $(`#${inputid}`);
      input.attr('type', 'password')

    }
  }
  new() {
    this.errors = new Errors();
    this.ModelRef.hide()
  }
  ngOnDestroy() {
    this.resetTimeOut();
    if (this.ModelRef)
      this.ModelRef.hide()

  }
  resetTimeOut() {
    this.idle.stop();
    this.idle.onIdleStart.unsubscribe();
    this.idle.onTimeoutWarning.unsubscribe();
    this.idle.onIdleEnd.unsubscribe();
    this.idle.onIdleEnd.unsubscribe();


  }
  selectUser: any;
  logoutconfirm(data, confirm: TemplateRef<any>) {

    if (this.currentUser.item) {
      this.ufname = this.currentUser.item.firstName;
      this.ulname = this.currentUser.item.lastName;
    }
    let self = this;
    self.selectUser = data
    ////console.log(window.localStorage['cnusername']);
    if (this.currentUser.item) {
      this.ModelRef = self.modalService.show(confirm, {
        class: 'modal-md',
        backdrop: 'static'
      })
      this.movable()
      this.password = ''
    } else {
      this.logout();
    }


  }
  movable() {
    $(function () {
      let modalContent: any = $('.modal-content');
      let modalHeader = $('.modal-header');
      modalHeader.addClass('cursor-all-scroll');
      modalContent.draggable({
        handle: '.modal-header'
      });
    });
  }
  logintocc() {
    let uname;
    uname = this.currentUser.item.userId
    this.isSubmitting = true;
    this.errors = new Errors();
    let self = this;
    //  this.logout();
    self.patientservice.getPatientPassword(uname, this.currentUser.item.userAccountId)
      .subscribe(data => {
        if (data.item.status == 'success') {
          if (btoa(this.reauth.value.password) == data.item.pwd) {
            this.loginAsCareCoordinator(this.selectUser)
          } else {
            this.errors = {
              'error': 'Invalid Password',
              'message': 'Invalid Password',
              'passwordattempt': null,
              'userGroupid': null
            };
            this.isSubmitting = false;
          }
        }
      })
  }


  getTitle(clientName) {
    return `${clientName}'s Users List`
  }


  //Clear  Filter data
  clearFilter(event) {
    this.dataGrid.instance.clearFilter();
  }
  getFullYear() {
    return new Date().getFullYear();
  }

}
